import React, { useEffect, useState, useRef } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import countdown_loading from '@assets/img/countdown_loading.png';
import EE from '@/common/event';
import Local from '@/common/helper/local';

const cacheKey = 'PLAN_QUESTION_COUNTDOWN_TIMEOUT';
const setCacheCount = (id, val, clear) => {
  const cacheData = Local.getItem(cacheKey) || {};
  if (clear) {
    try {
      delete cacheData[id];
    } catch (error) {}
  } else {
    cacheData[id] = val;
  }
  Local.setItem(cacheKey, cacheData);
};
const Countdown = observer(props => {
  const cacheData = Local.getItem(cacheKey) || {};
  const { className = '', planStepId, timeout, overrun, disable } = props;
  const [count, setCount] = useState(timeout);
  const [pause, setPause] = useState(false);
  // const isOver = count < 1 || disable;
  const isOver = count < 1;
  const timerRef = useRef(null);

  useEffect(() => {
    if (pause) {
      clearInterval(timerRef.current);
    } else {
      clearInterval(timerRef.current);
      timerRef.current = setInterval(() => {
        setCount(_count => {
          const count = _count - 1;
          setCacheCount(planStepId, count);
          return count;
        });
      }, 1000);
    }
  }, [pause]);

  useEffect(() => {
    if (isOver || disable) {
      setPause(true);
      clearInterval(timerRef.current);
      setCacheCount(planStepId, 0, true);
    }
    if (isOver) {
      overrun && overrun();
    }
  }, [isOver]);

  useEffect(() => {
    setCount(cacheData[planStepId] || timeout);
    const reload =()=>{
      setPause(true);
      clearInterval(timerRef.current);
      setCacheCount(planStepId, 0, true);
    }
    EE.on('confirm_countdown_pause', setPause);
    EE.on('confirm_countdown_reload', reload);

    return () => {
      EE.off('confirm_countdown_pause', setPause);
      EE.off('confirm_countdown_reload', reload);
    };
  }, []);

  if (isOver) return null;

  return (
    <div
      className={[
        className,
        'pl-10px h-32px min-w-218px flex items-center bg-[#006AFF0F] bg-opacity-6',
        'border-1px border-[#006AFFB2] border-opacity-70 rounded-12px',
        'text-[#FF3B30]',
      ]}
      data-flag="1"
    >
      <img
        src={countdown_loading}
        className={['size-16px', pause ? '' : 'animate-spin']}
        alt=""
      />
      <div className="ml-6px text-13px text-[#006AFF]">
        {count}s 后AI自行判断需求并执行
      </div>
    </div>
  );
});
export default Countdown;
